import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Flights from "../pages/flights/page";
import BookingInquiry from "../pages/booking-inquiry/page";
import ToursPage from "../pages/tours/page";
import TourDetailPage from "../pages/tours/detail/page";
import InsurancePage from "../pages/insurance/page";
import VisaPage from "../pages/visa/page";
import VisaDetailPage from "../pages/visa/detail/page";
import UmrahPage from "../pages/umrah/page";
import UmrahDetailPage from "../pages/umrah/detail/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/flights", element: <Flights /> },
  { path: "/booking-inquiry", element: <BookingInquiry /> },
  { path: "/tours", element: <ToursPage /> },
  { path: "/tours/:slug", element: <TourDetailPage /> },
  { path: "/insurance", element: <InsurancePage /> },
  { path: "/visa", element: <VisaPage /> },
  { path: "/visas", element: <VisaPage /> },
  { path: "/visa/:slug", element: <VisaDetailPage /> },
  { path: "/umrah", element: <UmrahPage /> },
  { path: "/umrah/:slug", element: <UmrahDetailPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
